export default __webpack_public_path__ + "static/hero-curve-keypad-c93bd7e86beebfa1b8aa2fbc0679499f.png";